import React from "react";
import { Box } from "@material-ui/core";

import { useSelector } from "react-redux";
import { getAuthInfo } from "store/slices/auth";

import Loading from "components/Common/Loading";
import StaffDetail from "views/Admin/Component/Staff/StaffDetail";

const OnBoard = () => {
  const authInfo = useSelector(getAuthInfo) || {};


  if (!authInfo) {
    return (<Loading />);
  }

  return (
    <Box>
      {
        authInfo && <StaffDetail workerId={authInfo.id} />
      }
    </Box >
  );
}

export default OnBoard;
